import React from 'react';

function money(v) {
    const n = parseFloat(v) || 0;
    return `${n >= 0 ? '+' : ''}$${n.toFixed(2)}`;
}

function cls(v) {
    const n = parseFloat(v) || 0;
    return n > 0 ? 'text-success fw-bold' : n < 0 ? 'text-danger fw-bold' : 'text-muted';
}

// Percentual de retorno (ROI = lucro ÷ custo investido). null = sem base de custo → não exibe.
function pctStr(v) {
    if (v === null || v === undefined) return '';
    const n = parseFloat(v);
    return `${n >= 0 ? '+' : ''}${n.toFixed(2)}%`;
}

function Breakdown({ title, labelHeader, rows }) {
    return (
        <div className='col-12 col-lg-6 mb-3'>
            <div className='card card-body border-0 shadow h-100'>
                <h6 className='mb-3'>{title}</h6>
                {rows && rows.length ? (
                    <div className='table-responsive'>
                        <table className='table table-sm table-hover mb-0 align-middle'>
                            <thead>
                                <tr>
                                    <th>{labelHeader}</th>
                                    <th className='text-end'>Trades</th>
                                    <th className='text-end'>Win</th>
                                    <th className='text-end'>ROI</th>
                                    <th className='text-end'>Resultado</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map(r => (
                                    <tr key={r.key}>
                                        <td><strong>{r.key}</strong></td>
                                        <td className='text-end text-muted' style={{ fontSize: 13 }}>{r.trades}</td>
                                        <td className='text-end text-muted' style={{ fontSize: 13 }}>{r.winRate != null ? r.winRate + '%' : '—'}</td>
                                        <td className={`text-end ${cls(r.pct)}`} style={{ fontSize: 13 }}>{r.pct != null ? pctStr(r.pct) : '—'}</td>
                                        <td className={`text-end ${cls(r.profit)}`} style={{ fontSize: 13 }}>{money(r.profit)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : <p className='text-muted small mb-0'>Nenhum trade fechado no período.</p>}
            </div>
        </div>
    );
}

// Comparação Spot × Futuros lado a lado (visão de portfólio). Só aparece quando há resultado
// de futuros (senão é redundante com o total spot). Cada cartão = resultado realizado do mercado.
function MarketCompare({ rows }) {
    if (!rows || rows.length < 2) return null;
    const get = key => rows.find(r => r.key === key) || { profit: 0, trades: 0, winRate: null, pct: null };
    const cards = [
        { key: 'Spot', icon: '🪙', ...get('Spot') },
        { key: 'Futuros', icon: '⚡', ...get('Futuros') },
    ];
    return (
        <div className='row g-2 mb-3'>
            {cards.map(c => (
                <div className='col-6' key={c.key}>
                    <div className='border rounded p-2 h-100'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <span className='text-muted small'>{c.icon} {c.key}</span>
                            <span className={cls(c.profit)} style={{ fontSize: 15 }}>
                                {money(c.profit)}{c.pct != null ? <span style={{ fontSize: 12 }}> ({pctStr(c.pct)})</span> : ''}
                            </span>
                        </div>
                        <div className='text-muted' style={{ fontSize: 12 }}>
                            {c.trades} trade{c.trades === 1 ? '' : 's'}{c.winRate != null ? ` · win ${c.winRate}%` : ''}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

/**
 * Resultado REALIZADO do período (só operações fechadas), por estratégia, moeda e mercado.
 * props: data = { total, byStrategy[], byCoin[], byMarket[] }
 */
function ResultsBreakdown({ data }) {
    if (!data) return null;
    const total = parseFloat(data.total) || 0;
    const totalPct = data.totalPct;

    return (
        <div className='card card-body border-0 shadow mb-4'>
            <div className='d-flex justify-content-between align-items-center mb-1 flex-wrap'>
                <h5 className='mb-0'>Resultado Realizado do Período</h5>
                <h4 className={`mb-0 ${cls(total)}`}>
                    {money(total)}{totalPct != null ? <span style={{ fontSize: 16 }}> ({pctStr(totalPct)})</span> : ''}
                </h4>
            </div>
            <small className='text-muted mb-3 d-block'>
                Soma do lucro/prejuízo das operações <strong>fechadas</strong> (pares compra→venda) no período.
                O <strong>%</strong> é o retorno sobre o capital investido (ROI = lucro ÷ custo das compras).
                Posições <strong>abertas</strong> aparecem abaixo, separadas (não-realizado).
            </small>
            <MarketCompare rows={data.byMarket} />
            <div className='row'>
                <Breakdown title='Por Estratégia' labelHeader='Estratégia' rows={data.byStrategy} />
                <Breakdown title='Por Moeda' labelHeader='Moeda' rows={data.byCoin} />
            </div>
        </div>
    );
}

export default ResultsBreakdown;
